import { useState } from "react";
import { Badge, EditRowActions, Group, Td, Text, Tr } from "@/components/ui";
import type { CentroDeCostoConOrganizaciones } from "@/lib/types";
import type { EditarCecoInput } from "../services/catalogos-contables-admin-service";
import { CecoEditarDialog } from "./CecoEditarDialog";

/** Fila del gestor de relaciones · código + nombre + badges de organización(es) + editar. */
export function CecoConOrgsRow({
  ceco,
  onGuardar,
  isPending,
  etiqueta,
  nota,
}: {
  etiqueta?: string;
  nota?: string;
  ceco: CentroDeCostoConOrganizaciones;
  onGuardar: (args: { id: string; input: EditarCecoInput }) => void;
  isPending: boolean;
}) {
  const [editando, setEditando] = useState(false);

  return (
    <>
      <Tr>
        <Td>
          <Text size="xs" ff="mono">
            {ceco.codigo}
          </Text>
        </Td>
        <Td>
          <Text size="sm">{ceco.nombre}</Text>
        </Td>
        <Td>
          {ceco.organizaciones.length === 0 ? (
            <Text size="xs" c="dimmed">
              Sin organización
            </Text>
          ) : (
            <Group gap={4} wrap="wrap">
              {ceco.organizaciones.map((o) => (
                <Badge key={o.numeroSociedad} size="sm" variant="light" color="multiva" title={o.nombre}>
                  <span className="font-mono">{o.numeroSociedad}</span> · {o.nombre}
                </Badge>
              ))}
            </Group>
          )}
        </Td>
        <Td align="right">
          <EditRowActions mode="view" onEdit={() => setEditando(true)} />
        </Td>
      </Tr>
      {editando ? (
        <CecoEditarDialog
          etiqueta={etiqueta}
          nota={nota}
          ceco={ceco}
          open={editando}
          onClose={() => setEditando(false)}
          onGuardar={(args) => {
            onGuardar(args);
            setEditando(false);
          }}
          isPending={isPending}
        />
      ) : null}
    </>
  );
}
